export const set_error = (error) => ({
  type: "SET_ERROR",
  payload: error,
});

export const clear_error = () => ({
  type: "CLEAR_ERROR",
});
